import FingerPrint from '@/plugins/fingerprint2'
const finger = new FingerPrint()
finger.run()
